/**
 * Retrieves a section using the Section Rendering API
 *
 * @param {String} url - URL of the section to return
 * @returns HTMLElement
 */
export const fetchSection = (url) =>
  fetch(url)
    .then((res) => res.text())
    .then((html) =>
      new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".shopify-section")
    );


class ProductPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll("[data-variant]").forEach((el) => {
      el.addEventListener("click", this.handleVariantClick.bind(this));
    });

    document.addEventListener("productPopupLoaded", () => {
      this.querySelectorAll("[data-variant]").forEach((el) => {
        el.addEventListener("click", this.handleVariantClick.bind(this));
      });
    })
  }

  async handleVariantClick(e) {
    this.productPopup = this.querySelector("[data-product-popup]");
    fetchSection(
      `/products/${e.target.dataset.variant}?section_id=product-buy__popup`
    ).then((section) => {
      if (section.querySelector("[data-product-popup]") !== null) {
        this.productPopup.innerHTML = section.querySelector("[data-product-popup]").innerHTML;
      }

      this.querySelectorAll("[data-variant]").forEach((el) => {
        el.addEventListener("click", this.handleVariantClick.bind(this));
      });

      this.querySelector(".prd-Card_Popup-Close").addEventListener("click", this.handleClose.bind(this));
    });
  }

  // we have to do this to reset the popup data on close 
  async handleClose() {
    this.productPopup = this.querySelector("[data-product-popup]");
    fetchSection(
      `/products/${this.dataset.product}?section_id=product-buy__popup`
    ).then((section) => {
      if (section.querySelector("[data-product-popup]") !== null) {
        this.productPopup.innerHTML = section.querySelector("[data-product-popup]").innerHTML;
      }

      this.querySelectorAll("[data-variant]").forEach((el) => {
        el.addEventListener("click", this.handleVariantClick.bind(this));
      });
    });
  }
}

customElements.define("product-popup", ProductPopup);
